<div class="row page-header">
    <div class="col-12">
        <h1>Drafting Queue <small>(Beta) Pieces awaiting IFF approval</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <div class="form-group me-3 mb-2">
                    <label class="me-2" for="fabDraftJobSelect">Job</label>
                    <wj-combo-box
                        id="fabDraftJobSelect"
                        name="fabDraftJobSelect"
                        [(ngModel)]="selectedJobId"
                        [itemsSource]="jobOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        (selectedIndexChanged)="onJobChanged()"
                        style="width: 22rem"
                    ></wj-combo-box>
                </div>
                <action-toolbar-count [grid]="grid"></action-toolbar-count>
                <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <grid-column-group [grid]="grid"></grid-column-group>
            <wj-flex-grid
                id="pendingGrid"
                #pendingGrid
                appAutoSize
                (initialized)="grid.initialize(pendingGrid)"
                (destroy)="grid.destroy()"
                [itemsSource]="grid.view"
                [itemFormatter]="itemFormatter"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Job'" [binding]="'jobDisplayName'" [width]="220"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Scope'" [binding]="'scope'" [width]="120"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'DWG #'" [binding]="'markCode'" [width]="90"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'" [minWidth]="140"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'IFA Planned'"
                    [binding]="'ifaPlanned'"
                    [width]="100"
                    [format]="'yyyy-MM-dd'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'IFA'"
                    [binding]="'ifaDate'"
                    [width]="110"
                    [format]="'yyyy-MM-dd'"
                    [editor]="inputDate"
                    [isRequired]="false"
                    [isReadOnly]="!canEdit"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'IFF Planned'"
                    [binding]="'iffPlanned'"
                    [width]="100"
                    [format]="'yyyy-MM-dd'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'IFF'"
                    [binding]="'iffDate'"
                    [width]="110"
                    [format]="'yyyy-MM-dd'"
                    [editor]="inputDate"
                    [isRequired]="false"
                    [isReadOnly]="!canEdit"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Risk'" [binding]="'riskLevel'" [width]="90" [isReadOnly]="true"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Days Late'"
                    [binding]="'daysLate'"
                    [width]="80"
                    [align]="'center'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Hold'" [binding]="'holdReasonName'" [width]="140" [isReadOnly]="true"></wj-flex-grid-column>
            </wj-flex-grid>
            <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <h4>Recently Approved (last 14 days)</h4>
            <wj-flex-grid
                id="recentGrid"
                #recentGridEl
                appAutoSize
                (initialized)="recentGrid.initialize(recentGridEl)"
                (destroy)="recentGrid.destroy()"
                [itemsSource]="recentGrid.view"
                [itemFormatter]="itemFormatter"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Job'" [binding]="'jobDisplayName'" [width]="220"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Scope'" [binding]="'scope'" [width]="120"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'DWG #'" [binding]="'markCode'" [width]="90"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'IFF'"
                    [binding]="'iffDate'"
                    [width]="110"
                    [format]="'yyyy-MM-dd'"
                ></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
    </div>
</div>
